/**
 * Author:hong.rong
 * Desc:存储工具类
 * Date:2022-01-25
 */

import Cookies from 'js-cookie'
import isString from 'lodash/isString'
import isNumber from 'lodash/isNumber'
import { COOKIES_MAP } from '@/constants'
import { isServer } from '@/utils'
import config from '@/utils/config'

export function setStorage(key: string, val?: any): void {
  if (isServer()) return
  if (isString(val)) {
    localStorage.setItem(key, val)
  } else if (isNumber(val)) {
    localStorage.setItem(key, `${val}`)
  } else {
    localStorage.setItem(key, JSON.stringify(val))
  }
}

export function getStorage(key: string): any {
  if (isServer()) return null
  return localStorage.getItem(key)
}

export function removeStorage(key: string): void {
  if (isServer()) return
  localStorage.removeItem(key)
}

export function clearStorageAll() {
  if (isServer()) return
  const cacheChannel = getStorage('channel')
  const filterCollapse = getStorage('cb_filter_collapse')
  const cacheLastLoginTab = getStorage('lastLoginTab')
  localStorage.clear()
  if (cacheChannel) {
    // sso不删除
    setStorage('channel', cacheChannel)
  }
  if (filterCollapse) {
    // 列表高级筛选不删除
    setStorage('cb_filter_collapse', filterCollapse)
  }
  if (cacheLastLoginTab) {
    setStorage('lastLoginTab', cacheLastLoginTab)
  }
  // 处理cookie
  Cookies.remove(COOKIES_MAP.TOKEN)
}

export function setCookie(v: any, k?: string) {
  if (!k) {
    // Cookies.set(COOKIES_MAP.TOKEN, v, { expires: config.expires })
    Cookies.set(COOKIES_MAP.TOKEN, v)
  } else {
    Cookies.set(k, v, { expires: config.expires })
  }
}

export function getCookie(k: string) {
  if (!k) {
    return null
  }
  return Cookies.get(k)
}

export function removeCookie() {
  // 兼容旧token
  Cookies.remove(COOKIES_MAP.LANGUAGE)
  Cookies.remove(COOKIES_MAP.TOKEN)
  Cookies.remove(COOKIES_MAP.USER_FAVORITE)
  Cookies.remove(COOKIES_MAP.IS_SSO)
}

/**
 * 初始化主体、权限、用户信息使用
 * @param key
 * @param initialValue
 * @returns
 */
export function getInitialValueFromStorage(key: string, initialValue?: any): any {
  if (isServer()) return null
  try {
    const v: any = getStorage(key)
    if (v === 'true' || v === 'false') {
      return v === 'true'
    }
    if (initialValue) {
      if (!v) {
        return initialValue
      }
      // 对象或者数组
      return JSON.parse(v)
    }
    return v
  } catch (e) {
    console.error(e)
    return initialValue || null
  }
}
